import * as React from 'react';
import { connect } from 'react-redux';

import ActionButton from 'components/buttons/action-button/ActionButton';

import {
  moveToCreateCollection,
  saveToCustomCollection,
  saveToSmartCollection
} from 'modules/create-new-profiles/reducers/actions';

import { __t, applyTranslations } from 'utils/language';
import { getSetOfButtonsForCreateNewProfilesConfirmationModal } from 'modules/create-new-profiles/utils/modal-buttons';

import {
  CreateNewProfilesOpenedOn
} from 'modules/create-new-profiles/types/CreateNewProfiles.type';
import { State } from 'types';

applyTranslations(require('./create-new-profiles-confirmation-modal-buttons.i18n.json'));

interface StateProps {
  openedOn: CreateNewProfilesOpenedOn,
  wantToCreateNewCollection: boolean
}

interface DispatchProps {
  dispatchOnClose: (o: CreateNewProfilesOpenedOn) => void,
  dispatchOnContinue: () => void,
  dispatchOnOkay: () => void
}

type Props = StateProps & DispatchProps;

const CreateNewProfilesConfirmationModalButtons = ({
  openedOn,
  wantToCreateNewCollection,
  dispatchOnOkay,
  dispatchOnClose,
  dispatchOnContinue
}: Props): JSX.Element | null => {
  const buttons = getSetOfButtonsForCreateNewProfilesConfirmationModal(
    openedOn,
    wantToCreateNewCollection,
    {
      okay: {
        text: __t('create_new_profiles_confirmation_modal_buttons.okay'),
        action: dispatchOnOkay
      },
      close: {
        text: __t('create_new_profiles_confirmation_modal_buttons.close'),
        action: () => dispatchOnClose(openedOn)
      },
      continue: {
        text: __t('create_new_profiles_confirmation_modal_buttons.continue'),
        action: dispatchOnContinue
      }
    }
  );

  return (
    <React.Fragment>
      {buttons.map(button => (
        <ActionButton
          key={button.type}
          color={button.type}
          onClick={button.action}
        >
          {button.text}
        </ActionButton>
      ))}
    </React.Fragment>
  );
};

const mapStateToProps = ({ createNewProfiles }: State): StateProps => ({
  openedOn: createNewProfiles.openedOn,
  wantToCreateNewCollection: createNewProfiles.confirmationModal?.wantToCreateNew ?? false
});

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchOnContinue: () => dispatch(moveToCreateCollection()),
  dispatchOnClose: openedOn => (
    openedOn === 'custom-collection'
      ? dispatch(saveToCustomCollection())
      : dispatch(saveToSmartCollection())
  ),
  dispatchOnOkay: () => dispatch(saveToCustomCollection())
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateNewProfilesConfirmationModalButtons);
